import { Injectable } from "@angular/core";
import * as signalR from "@microsoft/signalr";
import { Subject } from "rxjs/internal/Subject";
import {
  IInitResponse,
  ISendWave,
  ISendTradeData,
  ISendTradeDataResponse,
  AnnotationTypes,
} from "../Models/HubModels";
import { Configs } from "../Models/Configs";
import { IRetracementSettingsRow } from "../Models/RetracementSettings";
import { CookiesService } from "./cookieService";
import { DialogLoginComponent } from "../Dialogs/dialog.login/dialog.login.component";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ReloadDialogComponent } from "../Dialogs/reload/reload.component";
import { DGDrawingServiceGlobal } from './DrawingService';
import { UTCTimestamp } from "lightweight-charts";
import * as moment from "moment";

@Injectable({
  providedIn: "root",
})
export class DgHubClientService {
  connection: signalR.HubConnection;
  connectionLogin: signalR.HubConnection;
  baseUrl: string;
  keepAlive = 5;

  InitResponse: Subject<IInitResponse> = new Subject<IInitResponse>();
  SendWaveResponse: Subject<ISendWave> = new Subject<ISendWave>();
  RetracementSettingsResponse: Subject<RetracementSettingsRequest> = new Subject<RetracementSettingsRequest>();
  SendTradeData: Subject<ISendTradeDataResponse> = new Subject<
    ISendTradeDataResponse
  >();

  StrikeTick: Subject<SimbleBidAsk[]> = new Subject<SimbleBidAsk[]>();
  StrikeSumSingleTick: Subject<CountsData> = new Subject<CountsData>();
  StrikeSumAllTick: Subject<CountsData[]> = new Subject<CountsData[]>();
  ResetStrikes: Subject<CountsData[]> = new Subject<CountsData[]>();
  SignalTick: Subject<CountsData> = new Subject<CountsData>();
  SendTomorrowDayDataTick:Subject<TradeDataEvent[]> = new Subject<TradeDataEvent[]>();
  SendLastTomorrowDayDataTick:Subject<TradeDataEvent> = new Subject<TradeDataEvent>();
  ReceiveTrackedStrikeTradeInfoTick:Subject<SimbleBidAsk> = new Subject<SimbleBidAsk>();
  ReceiveTrackedStrikeTradeInfoListTick:Subject<CountsData[]> = new Subject<CountsData[]>();

  constructor(private cookieService: CookiesService, public dialog: MatDialog) {
    Configs.init(this);
  }

  ConnectMain(): Promise<void> {
    if (!this.connection) {
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(`${this.baseUrl}/main`, {
          logMessageContent: true,
          logger: signalR.LogLevel.Debug,
        })
        .configureLogging(signalR.LogLevel.Debug)
        .withAutomaticReconnect()
        .build();

      this.connection.keepAliveIntervalInMilliseconds = this.keepAlive * 1000;
      this.connection.serverTimeoutInMilliseconds = 32000; // 32s

      this.InitCallbacks();

    //  this.reloadDialog.close();

      return this.connection
        .start()
        .then(() => {

         })
        .catch((e) => {
          console.log("site_reload_before_error")
          console.log(e);
          this.reloadDialogOpen();
        
        });
    }
  }

  public reloadDialog: MatDialogRef<ReloadDialogComponent, any>;

  public reloadDialogOpen() {
    this.reloadDialog = this.dialog.open(ReloadDialogComponent, {
      maxWidth: "400px",
      disableClose: true,
    });

    // this.reloadDialog.afterClosed().subscribe((v) => {
    //   window.location.href = "/";
    // });
  }

  ConnectLogin() {
    if (!this.connectionLogin) {
      this.connectionLogin = new signalR.HubConnectionBuilder()
        .withUrl(`${this.baseUrl}/login`, {
          logMessageContent: true,
          logger: signalR.LogLevel.Debug,
        })
        .configureLogging(signalR.LogLevel.Debug)
        .withAutomaticReconnect()
        .build();

      this.connectionLogin.keepAliveIntervalInMilliseconds = this.keepAlive * 1000;
      this.connectionLogin.serverTimeoutInMilliseconds = 60000; // 32s

      let lastToken = this.cookieService.getCookie("_tk");

      if (lastToken == '') {
        this.showLogin();
      }
      else {
        this.connectionLogin
          .start()
          .then(() => {
            this.connectionLogin.send(
              "RefreshSession",
              lastToken
            );
          }).catch(()=>{
            this.reloadDialogOpen()
          })
      }
      //  this.InitCallbacks();


    }
  }
  public lastLogin: string;
  public dialogLogin;
  public connected: boolean = false;
  public showLogin(error?: string) {
    this.dialogLogin = this.dialog.open(DialogLoginComponent, {
      width: "400px",
      disableClose: true,
      backdropClass: "login-gradientPaddingTop",
      data: {
        email: "",
        password: "",
        rememberme: true,
        error: error
      },
    });
  }


  protected InitCallbacks() {
    this.connection.onclose((error) => {
      //console.log(this.connection.state);
      //console.log(error);
      this.connection = null;
      this.reloadDialogOpen();
      setTimeout(() => {
        this.ConnectMain();
      }, 500);
    });

    
    this.connection.onreconnected((connectionid) => {
      //console.log(this.connection.state);
      //console.log(connectionid);
      // this.connection.stop().then(v => {
      //   this.ConnectMain()
      // })
      // this.ConnectMain()
     DGDrawingServiceGlobal.drawingService().loaded = false;
     setTimeout(()=>{
      DGDrawingServiceGlobal.drawingService().loaded = true
     },30000)

      let lastToken = this.cookieService.getCookie("_tk");
     // DGDrawingServiceGlobal.drawingService().lastSelectedView =  DGDrawingServiceGlobal.drawingService().selectedViewName;
     // let selectedView =  DGDrawingServiceGlobal.drawingService().selectedViewName = '';//this.cookieService.getCookie("_view");
      // this.connection
      //   .send("LoginToMainHub", lastToken, '').then(v=>{
      //     //this.SelectView(selectedView)
      //    // DGDrawingServiceGlobal.drawingService().reconnection = true;
      //   });
    //   if(DGDrawingServiceGlobal.drawingService().selectedViewName!="null")
    //   {
    //      window.location.href=`/?viewId=${DGDrawingServiceGlobal.drawingService().selectedViewName}`;
    //   }
    //  else
    //  {
  //    window.location.href="/";
    // }
    console.log("sitereload_type3");

    });

    this.connection.onreconnecting((error) => {
      //console.log(this.connection.state);
      //console.log(error);
  //    this.reloadDialogOpen();
    });

   // this.connection.

    this.connection.on("HubLoginRequest", (r) => {
      // this.InitResponse.next(r);
      //console.log("HUBLOGIN");
      let lastToken = this.cookieService.getCookie("_tk");
      let selectedView = this.cookieService.getCookie("_view");
      this.connection
        .send("LoginToMainHub", lastToken, selectedView);

    });

    this.connection.on("InitResponse", (r) => {
      this.InitResponse.next(r);
    });

    this.connection.on("SendWave", (r) => {
      this.SendWaveResponse.next(r);
    });

    this.connection.on("SendTradeData", (r) => {
      this.SendTradeData.next(r);
    });

    this.connection.on("RetracementSettingstResponse", (r) => {
      this.SendTradeData.next(r);
    });

    this.connection.on("SendStrikeTick", (r) => {
   //   //console.log(r)
      this.StrikeTick.next(r);
    });

    this.connection.on("AllStrikeData", (r) => {
      this.StrikeSumAllTick.next(r);
    });

    this.connection.on("ResetStrikes", (r) => {
      this.ResetStrikes.next(r);
    });

    this.connection.on("SingleStrikeData", (r) => {
      this.StrikeSumSingleTick.next(r);
    });

    this.connection.on("SignalData", (r) => {
      this.SignalTick.next(r);
    });


    this.connection.on("SendTomorrowDayData", (r) => {
      console.log("SendTomorrowDayData");
      this.SendTomorrowDayDataTick.next(r);
    });

    this.connection.on("SendLastTomorrowDayData", (r) => {
      console.log("SendLastTomorrowDayData");
      this.SendLastTomorrowDayDataTick.next(r);
    });



    this.connection.on("ReceiveTrackedStrikeTradeInfo" , (r) => {
      this.SendLastTomorrowDayDataTick.next(r);
    });

    this.connection.on("ReceiveTrackedStrikeTradeInfoBatch" , (r) => {
      this.ReceiveTrackedStrikeTradeInfoListTick.next(r);
    });
  }

  ChangeSettings(request: SettingsRequest): Promise<void> {
    DGDrawingServiceGlobal.drawingService().loaded=false;
    return new Promise<void>((rs, rj) => {
      this.connection
        .send("UpdateSettings", request)
        .then(() => rs())
        .catch((e) => rj(e));
    });
  }

  ResetToDefault(activeViewName:string): Promise<void> {
    return new Promise<void>((rs, rj) => {
      this.connection
        .send("ResetToDefault", activeViewName)
        .then(() => rs())
        .catch((e) => rj(e));
    });
  }

  ChangeRetracementSettings(request: RetracementSettingsRequest): Promise<RetracementSettingsResponse> {
    //  return new Promise<void>((rs, rj) => {
    return this.connection
      .invoke<RetracementSettingsResponse>("RetracementSettings", request);

    // });
  }

  GetRetracementSettingsInit(): Promise<RetracementSettingsResponse> {
    //  return new Promise<void>((rs, rj) => {
    return this.connection
      .invoke<RetracementSettingsResponse>("GetRetracementSettingsInit");

    // });
  }

  StoreActiveRetracement(request: StoreRetracementReq): Promise<StoreRetracementReq> {
    //  return new Promise<void>((rs, rj) => {
    return this.connection
      .invoke<StoreRetracementReq>("StoreRetracement", request);

    // });
  }

  storePriceScaleRange(request: StorePriceRangeReq): Promise<StorePriceRangeReq> {
    //  return new Promise<void>((rs, rj) => {
    return this.connection
      .invoke<StorePriceRangeReq>("StorePriceScaleRange", request);

    // });
  }

  storeTimeScaleRange(request: StoreScaleRangeReq): Promise<StoreScaleRangeReq> {
    //  return new Promise<void>((rs, rj) => {
    return this.connection
      .invoke<StorePriceRangeReq>("StoreTimeScaleRange", request);

    // });
  }

  updateMagnituderState(request: MagnituderStateReq): Promise<MagnituderStateReq> {
    //  return new Promise<void>((rs, rj) => {
    return this.connection
      .invoke<MagnituderStateReq>("SetMagnituderAlertsState", request);

    // });
  }

  AddNewView(request: ViewSettingsReq): Promise<ViewSettingsReq> {

    return this.connection
      .invoke<ViewSettingsReq>("AddNewView", request);

  }

  GetViewsList(): Promise<ViewsListResponse> {

    return this.connection
      .invoke("GetViewList");

  }

  SelectView(viewName: string): Promise<ViewSettingsReq> {

    return this.connection
      .invoke<ViewSettingsReq>("SelectView", viewName);

  }

  NewStrikeSubscription(symbol: string): Promise<string> {

    return this.connection
      .invoke<string>("NewStrikeSubscription", symbol);

  }


  SetMinimumForRightBars(min: number): Promise<number> {

    return this.connection
      .invoke<number>("SetMinimumForRightBars", Number(min));

  }

  SetPreviousDayEventMode(mode: number): Promise<TradeDataEvent[]> {

    return this.connection
      .invoke<TradeDataEvent[]>("PreviousDayEventData", Number(mode));

  }

  TomorrowDayEventData(mode: number): Promise<TradeDataEvent[]> {

    return this.connection
      .invoke<TradeDataEvent[]>("TomorrowDayEventData", Number(mode));

  }

  setTrackedStrike(request:TrackedStrikeRequest)
  {
    return this.connection
    .invoke<boolean>("SaveTrackedStrike", request);

  }

  getAllTrackedStrike()
  {
    return this.connection
    .invoke<TrackedStrikes[]>("allTrackedStrikes");

  }




  removeSubscription(symbol: string): Promise<string> {

    return this.connection
      .invoke<string>("deleteSubscription", symbol);

  }

  testAction(): Promise<boolean> {

    return this.connection
      .invoke<boolean>("TestAction");

  }

  UpdateView(view:Views)
  {
    let req = new ViewReq();

    req.Id = view.id;
    req.UserId = view.userId;
    req.ViewName = view.viewName;

    return this.connection
    .invoke<ViewSettingsReq>("UpdateView", view);

  }

  DeleteView(view:Views)
  {
    let req = new ViewReq();

    req.Id = view.id;
    req.UserId = view.userId;
    req.ViewName = view.viewName;

    return this.connection
    .invoke<ViewSettingsReq>("DeleteView", view);

  }

  updateAnnotation(request: UpdateAnnotationReq){

    return this.connection
      .invoke<UpdateAnnotationReq>("UpdateAnnotation", request);

  }

  getSignals(){

    return this.connection
      .invoke<EventsResponse>("EventSignals");

  }


}


export class StorePriceRangeReq {
  range: string;
  viewName?:string;
}

export class StoreScaleRangeReq {
  range: string;
  viewName?:string;
}
export class MagnituderStateReq {
  state: boolean;
  viewName?:string;
}

export class SettingsRequest {
  numberOfWaves?: Number;
  totalNumberOfWaves?: Number;
  pernamentLineHeight?: Number;
  intermediateLineHeight?: Number;
  pernamentLineWidth?: Number;
  settings: Settings[];
  viewName?: string;
}

export class Settings {
  numberOfWaves: Number;
  totalNumberOfWaves: Number;
  pernamentLineHeight: Number;
  intermediateLineHeight: Number;
  pernamentLineWidth: Number;
  name: string;
  smaDiff: number;
}

export class RetracementSettingsRequest {
  upwave: RetracementSetting;
  downwave: RetracementSetting;
  viewName?:string;
}

export class RetracementSetting {
  name?: string;
  data?: string;
  userid?: string;
  type?: RetracementTypes
}

export class RetracementSettingsResponse {
  items: RetracementSetting[];
}

export enum RetracementTypes {
  UPWAVE = "UPWAVE",
  DOWNWAVE = "DOWNWAVE"
}

export class StoreRetracementReq {
  key: string;
  data: string;
  viewName?:string;
}

export class ViewSettingsReq
{
    viewName:string;
    settingsRequest?:SettingsRequest;
    activeRetracements?: StoreRetracementReq;
    upWave?: string;
    downWave?: string;
    priceRange?: StorePriceRangeReq;
    timeRange?: StoreScaleRangeReq;
}

export class ViewsListResponse
{
  views:Views[]
}


export class EventsResponse
{
  items:CountsData[];
}
export class Views
{
   id:number
   userId:string
   viewName:string
}


export class ViewReq
{
   Id:number
   UserId:string
   ViewName:string
}

export class UpdateAnnotationReq
{
  viewName:string;
  type:AnnotationTypes;
  data:string;
}

export class SimbleBidAsk
{
    bid:number
    ask:number

    bidSize:number
    askSize:number

    last:number

    lastVolume:number

   symbol:string
   exchange:string
}

export class TradeDataEvent
{
  public constructor(init?:Partial<TradeDataEvent>) 
  {
    Object.assign(this, init);
  }
   time:number;
   dateTime:Date;
   lastSize:number;
   strike:number;
   symbol:string;
   lastPrice:number;
   tradeInfo:string;
   get TradeInfoData():TradeInfo
   {
      return null;
   }
   get CountsDataConverted():CountsData
   {
      var countsData = new CountsData();
      if(this.tradeInfo)
      {
        var info = JSON.parse(this.tradeInfo);
        countsData.tradeInfo = new TradeInfo();
        countsData.tradeInfo.price = info.Price;
        countsData.tradeInfo.size = info.Size;
        countsData.tradeInfo.ssboe = info.Ssboe;
      }
      
      countsData.strike = this.strike;
      countsData.lastPrice = this.lastPrice;
      countsData.lastSize= this.lastSize;
      countsData.dateTime = this.dateTime;
      countsData.symbol = this.symbol
      countsData.isPreviousDay = true;
      return countsData;
   }
}
export class CountsData
{
  public constructor(init?:Partial<CountsData>) {
        Object.assign(this, init);
    }

    strike:number;
    lastSize:number;
    symbol:string;
    firstSum:number;
    secondSum:number;
    thirdSum:number;
    firstSumCash:number;
    secondSumCash:number;
    thirdSumCash:number;
    firstSumPoints:number;
    secondSumPoints:number;
    thirdSumPoints:number;
    firstCount:number;
    secondCount:number;
    thirdCount:number;
    diffFirstNowSeconds:number;
    diffSecondNowSeconds:number;
    diffThirdNowSeconds:number;
    lastPrice:number;
    tradeInfo:TradeInfo;
    dateTime:Date;
    isPreviousDay:boolean;
    askPrice:number;
    bidPrice:number;
    get pnl()
    {
      //ITM dla CALL gdy kurs wykonania jest powyzej strike

      var value = null;
      if(this.symbol.includes(" C"))
      {
        value = (this.lastPrice - this.tradeInfo.price) - this.strike//(this.lastPrice - this.strike) - this.tradeInfo.price;
      }
      else
      {
        value = (this.lastPrice - this.tradeInfo.price) - this.strike///(this.strike - this.lastPrice) - this.tradeInfo.price;
      }

      return value;
    }

    get costOfTrade()
    {
      

      var value = (this.tradeInfo.price)*this.lastSize*50;
      return  Math.round(value); 
    }

    get points()
    {
      return Math.round(this.strike - this.lastPrice);
    }
    get pointsFixed()
    {
      return (this.strike - this.lastPrice).toFixed(1);
    }

    get tradeInfoPricePoints()
    {
      return Math.round(this.tradeInfo.price);
    }

    get tradeInfoPricePointsFixed()
    {
       return this.tradeInfo.price.toFixed(1);
    }

    get sizePrice()
    {
      return this.lastSize*this.tradeInfo.price;
    }

    get costColor()
    {
      var color = ["",""];

      if(Math.abs(this.points)<=20)
      {
        color[1] = "yellow-txt";
      }
      else if(this.points<-20)
      {
        color[1]="red-txt";
      }
      else if(this.points>20)
      {
        color[1]="green-txt";
      }

      return color;
    }

    get timeColor()
    {
        if(this.costOfTrade>=15000&&this.costOfTrade<50000)
        {
            return "#fc9c0e";
        }

        if(this.costOfTrade>=50000&&this.costOfTrade<150000)
        {
          return "#3478ed";
        }

        if(this.costOfTrade>=150000&&this.costOfTrade<250000)
        {
          return "#f0f40e";
        }

        if(this.costOfTrade>=250000&&this.costOfTrade<500000)
        {
          return "#f508ff";
        }

        if(this.costOfTrade>=500000&&this.costOfTrade<1000000)
        {
          return "#9408fe ";
        }

       

        if(this.costOfTrade>=1000000)
        {
          return "#FA4C59";
        }

        return "white";
    }


    get itm()
    {
      //ITM dla CALL gdy kurs wykonania jest powyzej strike
      var value = null;
      if(this.symbol.includes(" C"))
      {
        value = (this.lastPrice - this.tradeInfo.price)>this.strike
      }
      else
      {
        value = (this.lastPrice - this.tradeInfo.price)<this.strike
      }

      return value;
    }

    get costStr()
    {
      return `<b>${this.tradeInfoPricePoints}</b> / <b><span class="${this.costColor[1]}">$</span></b><b><span class="${this.costColor[1]}">${this.costOfTrade}</span>`;
    }

    get costStrTable()
    {
      return `<b><span style='color:${this.timeColor}'">$</span></b><b><span style='color:${this.timeColor}'">${this.costOfTrade}</span>`;
    }

    get formattedTime()
    {
      return moment(this.dateTime).format("hh:mm A")
    }

    get formattedTimeS()
    {
      return moment(this.dateTime).format("hh:mm")
    }
}

export class TradeInfo
{
    price:number;
    size:number;
    ssboe:UTCTimestamp;
}

export class TrackedStrikeRequest
{
     strike:string;
     side:string;
}

export class TrackedStrikes
{
    id:number;
    userId:string;
    strike:string;
    side:string;
    startTrackDate:Date;
    data:CountsData;
}
